import React, { useState } from "react";
import { NavLink as BaseNavLink } from "react-router-dom";
import { Box, styled } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { customColors } from "models/customColors";
import { useAppDispatch } from "store/hooks";
import { hideMenu } from "store/reducers/isMenuVisibleReducer";

const NavLink = styled(BaseNavLink)`
  color: ${customColors.grayText};

  & path {
    fill: ${customColors.grayText};
  }

  &.active path {
    fill: ${customColors.mainColor};
  }

  &:hover {
    color: ${customColors.mainColor} !important;
    path {
      fill: ${customColors.mainColor};
    }
  }
`;

const NestedItem = styled(Box)`
  color: ${customColors.grayText};

  & path {
    fill: ${customColors.grayText};
  }

  &:hover {
    color: ${customColors.mainColor} !important;
    circle,
    rect {
      stroke: ${customColors.mainColor};
    }
    path {
      fill: ${customColors.mainColor};
    }
  }
`;

/** @type {React.CSSProperties} */
const sx = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "10px",
  padding: "5px 12px",
  borderRadius: 4,
  fontSize: "14px",
  fontFamily: "Inter Medium",
  textDecoration: "unset",
  cursor: "pointer",
  userSelect: "none",
};

/** @param {{ label: string; to?: string; Icon: any; subItems?: any[]; guideClass?: string; }} props */
export const MenuItem = ({
  label,
  to,
  Icon = () => null,
  subItems = undefined,
  guideClass = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const dispach = useAppDispatch();

  const handleClickMenu = () => dispach(hideMenu());

  if (!subItems) {
    return (
      <NavLink
        to={to}
        style={({ isActive }) => ({
          ...sx,
          color: isActive ? customColors.mainColor : customColors.grayText,
          backgroundColor: isActive
            ? customColors.selector
            : customColors.lightGray,
        })}
        draggable={false}
        onClick={handleClickMenu}
        className={guideClass}
      >
        <Icon />
        {label}
      </NavLink>
    );
  }

  return (
    <>
      <NestedItem
        onClick={() => setIsExpanded(!isExpanded)}
        sx={sx}
        draggable={false}
        data-id={label}
      >
        <Icon />
        {label}
        {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </NestedItem>
      <Box sx={{ borderBottom: "thin solid lightgray" }} mb={1} />
      {isExpanded &&
        !!subItems?.length &&
        subItems.map(({ label, path, Icon = () => null, guideClass = "" }) => (
          <NavLink
            key={`${label}-${path}`}
            to={path}
            style={({ isActive }) => ({
              ...sx,
              paddingLeft: "3rem",
              color: isActive ? customColors.mainColor : customColors.grayText,
              backgroundColor: isActive
                ? customColors.selector
                : customColors.lightGray,
              marginLeft: 10,
            })}
            draggable={false}
            onClick={handleClickMenu}
            className={guideClass}
          >
            <Icon />
            {label}
          </NavLink>
        ))}
      {isExpanded && (
        <Box sx={{ borderBottom: "thin solid lightgray" }} mb={1} />
      )}
    </>
  );
};
